<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :large="large"
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon>
        <span>Importar Solução</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-select
              id="group-solution-select"
              v-model="payload.grupoSolucao"
              item-text="nome"
              item-value="municipioGrupoSolucaoId"
              :items="groupSolutionList"
              label="Grupo de Solução"
              placeholder="Grupo de Solução"
              :return-object=true
              @change="changeGroupSolution"
            >
              <template slot="no-data">
                Nenhum Grupo de Solução retornado
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-combobox
              v-model="payload.grupoSolucao.solucoesOriginais"
              :items="solucoes"
              chips
              clearable
              label="Soluções"
              item-text="nome"
              item-value="solucaoId"
              multiple
            >
              <template slot="no-data">
                Nenhuma Solução retornada
              </template>
            </v-combobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { solutionAPI } from '@/modules/solution'
import { cityGroupSolutionAPI, citySolutionAPI } from '@/modules/city'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppModalImportGroupSolution',
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  data () {
    return {
      payload: {
        municipioId: this.$route.params.id,
        grupoSolucao: {
          solucoes: []
        }
      },
      dialog: false,
      groupSolutionList: [],
      solucoes: []
    }
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      this.setLoading(true)
      this.payload.grupoSolucao.usuarioId = this.user.usuarioId;
      citySolutionAPI.addByGrupoSolucao(this.payload.grupoSolucao)
        .then(resp => {
          this.setLoading(false)
          this.$notification.success('Solução incluída com sucesso')
          this.dialog = false
          this.$emit('onSave')
          this.getGroupSolution()
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao incluir grupo solução')
        })
    },
    changeGroupSolution () {
      this.setLoading(true)
      solutionAPI.getByGrupo(this.payload.grupoSolucao)
        .then(resp => {
          this.solucoes = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter soluções')
        })
    },
    getGroupSolution () {
      cityGroupSolutionAPI.listByCity(this.$route.params.id)
        .then(resp => {
          this.groupSolutionList = resp.data
        })
        .catch()
    }
  },
  mounted () {
    this.getGroupSolution()
  }
}
</script>
